module.exports = __webpack_public_path__ + "img/icon-marker-accent-6.a8781ca8.svg";